<template>
    <section class="product-share">
        <Tooltip :placement="shareTarget === 0 ? 'bottom-end' : 'top'">
            <Button class="btn-icon">
                <i class="iconfont icon-sharen"></i>
                <span v-if="shareTarget === 1">分享</span>
            </Button>
            <div slot="content">
                <div class="wechat">
                    <div class="top">
                        <i class="iconfont icon-wechat"></i>
                        <span class="top-title">分享到微信</span>
                    </div>
                    <div class="middle">
                        <img v-if="!!wCode" :src="'data:image/png;base64,'+ wCode" alt="">
                    </div>
                    <div class="bottom">
                        <span class="bottom-text">
                            用微信“扫一扫”分享给微信好友或朋友圈
                        </span>
                    </div>

                </div>
            </div>
        </Tooltip>
    </section>
</template>
<script>
    import api from '../../api';

    export default {
        data() {
            return {
                hasCode: false,
                wCode: '',
            };
        },
        props: {
            shareTarget: {
                type: Number,
                default: 0
            },
            type: {
                type: [Number,String],
                default: 1
            },
           inspiration: {
               type:[Number,String],
               default:0
           }
        },
        methods: {
            getProductCode() {
                api.products.getProductCode({resourceId: this.$route.params.id, type:this.type})
                    .then(res => {
                        this.wCode = res.resourceCode;
                    });
            },
             getProductNewCode() {
                api.products.product_new_code({collectionId: this.$route.params.id})
                    .then(res => {
                        this.wCode = res.productCode;
                    });
            }
        },
        created() {
            Number(this.inspiration) === 1 ? this.getProductCode() : this.getProductNewCode();
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss">
    .product-share {
        float: right;
        margin-top: -5px;
        margin-right: -12px;
        .btn-icon {
            background: transparent;
            border: transparent;
            span{
                font-size: 20px;
                color: #353838;
                vertical-align: middle;
                cursor: pointer;
            }
            .icon-sharen {
                color: #6C6F70;
            }
            &:hover i{
                color: #308697;
            }
            &:hover span{
                color: #308697;
            }
        }
        .wechat {
            width: 240px;
            height: 194px;
            .top {
                padding-top: 11px;
                text-align: center;
                .icon-wechat {
                    color: #1ABB0E;
                    &:before {
                        content: "\E8FC";
                    }
                }
                &-title {
                    font-size: 14px;
                    color: #353838;
                    letter-spacing: 0;
                }
            }
            .middle {
                font-size: 0;
                text-align: center;
                padding-top: 13px;
                > img {
                    width: 105px;
                    height: 105px;
                }
            }
            .bottom {
                text-align: center;
                padding-top: 12px;
                &-text {
                    font-size: 10px;
                    color: #308697;
                    letter-spacing: 0;
                }
            }
        }
        .ivu-tooltip-arrow {
            border-bottom-color: transparent !important;
        }
        .ivu-tooltip-inner {
            padding: 0;
            background: #FFFFFF;
            box-shadow: 0 1px 2px 0 #A2A2A8;
            border-radius: 4px;
        }
    }
</style>